module.exports = __webpack_public_path__ + "static/img/son9_active.fec7f5b0.png";